<lib-titled-card>
  <h2>Point of Contact</h2>
  <p class="note">
    A Point of Contact (POC) having access to your record will be discontinued as we transition to the new license management
    system.
  </p>
  <section class="card-section" *ngIf="canHavePOC">
    <div *ngIf="hasPointOfContact">
      <lib-point-of-contact-list [list$]="pointOfContacts$" [isStaffView]="isStaffView"> </lib-point-of-contact-list>
    </div>
  </section>

  <hr />

  <section class="card-section">
    <h3>Access to Other Records</h3>
    <ng-container *ngIf="!isStaffView">
      <ng-template #cta>
        <div class="call-to-action">
          <p>Would you like to request to be the Point of Contact for an architect?</p>
          <span>
            <button
              mat-button
              class="large align-top"
              color="inverse"
              type="button"
              [routerLink]="['archpointofcontact/request']"
            >
              {{ terms.Request }} Access
            </button>
          </span>
        </div>
      </ng-template>
    </ng-container>
    <lib-point-of-contact-for-list
      *ngIf="isPointOfContact || isStaffView"
      [list$]="pointOfContactForList$"
      [isStaffView]="isStaffView"
    >
    </lib-point-of-contact-for-list>
  </section>
</lib-titled-card>
